// src/components/api/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://blog.dietchapter.hosting.acm.org/', // Local backend only
  withCredentials: true,
});

export default instance;
